const getCountry = () => {
  const locale = process.env.REACT_APP_LOCALE
  const country = locale.split('-')[1].toUpperCase()

  return country
}

export { getCountry }
